import FormattedMessage from 'I18n/components/FormattedMessage';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { useDetailsRenderConfig } from '../../providers/DetailsRenderConfigProvider';
import { HeaderDetailsRows } from './HeaderDetailRows';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderDetailsPanel = ({
  closeDetailsPanel,
  contentObject
}) => {
  const {
    detailsPanelConfig
  } = useDetailsRenderConfig();
  return /*#__PURE__*/_jsxs(Panel, {
    children: [/*#__PURE__*/_jsx(CloseButton, {
      onClick: closeDetailsPanel
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-details-lib.header.headerDetailsSidebar.header"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsx(PanelSection, {
        children: /*#__PURE__*/_jsx(DescriptionList, {
          children: /*#__PURE__*/_jsx(HeaderDetailsRows, {
            detailsRenderConfig: detailsPanelConfig,
            contentObject: contentObject
          })
        })
      })
    })]
  });
};
export default HeaderDetailsPanel;